import { log } from "@qgiv/core-js";
import {
    getIdOfPaymentIframeContainer,
    getParsedDataFromPostMessage,
    getPaymentIframeHandshakeEventName,
    getPaymentIframeResizeEventName,
} from "../../utility";

/**
 * @typedef {import("./types").HandleReceivePostMessageSettings} HandleReceivePostMessageSettings
 */

const idOfPaymentIframeContainer = getIdOfPaymentIframeContainer();
const paymentIframeHandshakeEvent = getPaymentIframeHandshakeEventName();
const paymentIframeResizeEvent = getPaymentIframeResizeEventName();

/**
 * @description Resizes the payment iframe whenever there are changes to the
 * size of the content in the payment application.
 * @param {HandleReceivePostMessageSettings} settings
 * @returns {void}
 */
export const handleResizeMessage = (settings) => {
    const { message } = settings;

    const parsedData = getParsedDataFromPostMessage(message);
    const { data } = parsedData;
    const { height } = data;

    log("PAYMENT IFRAME: RECEIVE PAYMENT IFRAME RESIZE");
    log({
        data,
    });

    /** @type {HTMLElement | null} */
    const paymentIframe = document.querySelector(
        `#${idOfPaymentIframeContainer}`,
    );
    const heightInPixels = `${height}px`;

    if (paymentIframe) {
        paymentIframe.style.height = heightInPixels;
    }
};

/**
 * @description Updates local component state because it means that we have
 * verified that we have successfully connected to the payment iframe and can
 * ignore any future handshakes that come through due to the fact that we had
 * to poll the payment iframe repeatedly.
 * @param {HandleReceivePostMessageSettings} settings
 * @returns {void}
 */
export const handleHandshakeMessage = (settings) => {
    const {
        hasReceivedHandshakeFromPaymentIframe,
        setHasReceivedHandshakeFromPaymentIframe,
    } = settings;
    log(
        "PAYMENT IFRAME: RECEIVE POST MESSAGE FROM PAYMENT IFRAME WITH HANDSHAKE RESPONSE",
    );

    if (!hasReceivedHandshakeFromPaymentIframe) {
        setHasReceivedHandshakeFromPaymentIframe(true);
    }
};

/**
 * @param {HandleReceivePostMessageSettings} settings
 * @returns {void}
 */
export const handleReceivePostMessage = (settings) => {
    const { message, originOfPaymentIframe } = settings;

    if (message.origin !== originOfPaymentIframe) {
        return;
    }

    const parsedData = getParsedDataFromPostMessage(message);

    if (parsedData.event === paymentIframeResizeEvent) {
        handleResizeMessage(settings);
    }

    if (parsedData.event === paymentIframeHandshakeEvent) {
        handleHandshakeMessage(settings);
    }
};
